import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  width: 800px;
  margin: 100px 0;
  justify-content: space-between;
`
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 50%;
`
export const TextElementMain = styled.p`
  font-size: 22px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 20px;
  text-align: left;
  max-width: 700px;
  color: ${(props) => props.theme.colors.account.text};
`
export const TextElement = styled.p`
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 20px;
  text-align: left;
  max-width: 700px;
  color: ${(props) => props.theme.colors.account.text};
  & span {
    display: block;
    color: ${(props) => props.theme.colors.link};
  }
`
export const ButtonWrapper = styled.div`
  display: flex;
  margin: 10px -8px 65px;
`
